import React, { createContext, useContext } from "react";
import { useSalePageContext } from "../SalePageContext";
import { useDelay } from "../utils/useDelay";
import useMainCtaClick from "../utils/useMainCTAhelper";

type IMainCtaButtonContextValue = {
    ctaText: string;
    strikedOffText?: string;
    onMainCtaClick: () => void;
    hide: boolean;
    delayTime?: string;
};

const initialContextValue: IMainCtaButtonContextValue = {
    ctaText: "",
    onMainCtaClick: () => {},
    hide: false,
};

const MainCtaButtonContext = createContext(initialContextValue);

export function MainCtaButtonContextProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const { sectionsData } = useSalePageContext();
    const { handleMainCtaClick } = useMainCtaClick();

    const ctaText = sectionsData.mainCtaButton.ctaText || "Register";
    const { strikedOffText, delayTime } = sectionsData.mainCtaButton;
    // TODO / INFO : @DEV this useDelay hook should be called in all child components where it is needed rather than directly in this context.
    // Right now this is not causing any unnecessary rerender anywhere but the correct way is to call it in child components only.
    // It is being followed in sales page architecture that everything that can change after initial render is kept/consumed in the children component only
    const { endDelay } = useDelay({ delayTime });
    const contextValue: IMainCtaButtonContextValue = {
        hide: !endDelay,
        ctaText,
        strikedOffText,
        delayTime,
        onMainCtaClick: handleMainCtaClick,
    };
    return (
        <MainCtaButtonContext.Provider value={contextValue}>
            {children}
        </MainCtaButtonContext.Provider>
    );
}

export function useMainCtaButtonContext() {
    return useContext(MainCtaButtonContext);
}
